import { useRef, useCallback, useEffect } from 'react';

export const useAbortController = () => {
    const abortControllerRef = useRef(null);
    const requestCounterRef = useRef(0);

    const getSignal = useCallback(() => {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }
        abortControllerRef.current = new AbortController();
        requestCounterRef.current++;
        return {
            signal: abortControllerRef.current.signal,
            requestId: requestCounterRef.current
        };
    }, []);

    const isCurrentRequest = useCallback((requestId) => {
        return requestId === requestCounterRef.current;
    }, []);

    useEffect(() => {
        return () => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
        };
    }, []);

    return {
        getSignal,
        isCurrentRequest
    };
}; 